import { createTheme } from '@mui/material/styles';
import { breakpoints } from './breakpoints';
import { components } from './components';
import { palette } from './palette';
import { shape } from './shape';
import { spacing } from './spacing';
import { typography } from './typography';

export const theme = createTheme({
  palette,
  typography,
  spacing,
  breakpoints,
  shape,
  components,
});

export type VyTheme = typeof theme;
